// Auth facade — mirrors api.js. Real Supabase Auth, or a mock session when
// VITE_MOCK=1 so the app runs with no cloud project configured.

import { MOCK } from './api.js';

let mockStaff = null;

const real = MOCK ? null : await import('./supabase.js');

export function getStaff() {
  return MOCK ? mockStaff : real.getStaff();
}

export async function loadStaff() {
  if (MOCK) return mockStaff;
  return real.loadStaff();
}

export async function signIn(email, password) {
  if (MOCK) {
    const { mockSignIn } = await import('./api.mock.js');
    mockStaff = await mockSignIn(email);
    return mockStaff;
  }
  return real.signIn(email, password);
}

export async function signOut() {
  if (MOCK) { mockStaff = null; return; }
  return real.signOut();
}

// Only the real client emits auth events; in mock mode this is a no-op.
export function onAuthStateChange(handler) {
  if (MOCK) return;
  real.supabase.auth.onAuthStateChange(handler);
}
